// HelpPopover.jsx — info icon + hover popover carrying description/example/tips
//
// Used inside FieldPicker's Option renderer, OperatorPicker's Option renderer,
// and next to the selected field label so the marketer keeps guidance after
// choosing.
//
// Content comes from fieldCatalog entries (fields + OPERATORS): description,
// example, and optional tips[]. Renders nothing if no description is provided.
import React, { useRef } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { HelpCircle } from 'lucide-react';

let _idCounter = 0;
const nextId = () => `help-pop-${++_idCounter}`;

const HelpPopover = ({ description, example, tips, size = 14, placement = 'right' }) => {
  const idRef = useRef(nextId());
  if (!description && !example && !(tips && tips.length)) return null;

  return (
    <>
      <span
        id={idRef.current}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 6, color: '#8898aa', cursor: 'help' }}
      >
        <HelpCircle size={size} />
      </span>
      <UncontrolledTooltip
        target={idRef.current}
        placement={placement}
        delay={{ show: 300, hide: 100 }}
        autohide={false}
      >
        <div style={{ maxWidth: 320, fontSize: 12.5, lineHeight: 1.45, textAlign: 'left', color: '#fff' }}>
          {description && <div>{description}</div>}
          {example && (
            <div style={{ marginTop: 6, color: '#e2e8f0' }}>
              <em>{example}</em>
            </div>
          )}
          {tips && tips.length > 0 && (
            <ul style={{ marginTop: 6, marginBottom: 0, paddingLeft: 16, color: '#e2e8f0' }}>
              {tips.map((t, i) => <li key={i} style={{ marginTop: 2 }}>{t}</li>)}
            </ul>
          )}
        </div>
      </UncontrolledTooltip>
    </>
  );
};

export default HelpPopover;
